import PageNotFound from "~/components/PageNotFound";

function NotFound() {
  return <PageNotFound />;
}

export default NotFound;
